(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__bvPcardDrawerBound) return;
    window.__bvPcardDrawerBound = true;

    const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');

    const cartSectionIds = () => {
      const ids = new Set();
      document.querySelectorAll('cart-items-component[data-section-id], cart-drawer-component[data-section-id]').forEach((el) => {
        if (el.dataset.sectionId) ids.add(el.dataset.sectionId);
      });
      return [...ids];
    };

    const loadCartLinesUpdateEvent = async () => {
      if (window.__bvCartLinesUpdateEvent) return window.__bvCartLinesUpdateEvent;
      const sources = ['@shopify/events', '@shopify/standard-events'];
      for (const src of sources) {
        try {
          const mod = await import(src);
          const Ctor = mod.CartLinesUpdateEvent;
          if (typeof Ctor === 'function') {
            window.__bvCartLinesUpdateEvent = Ctor;
            return Ctor;
          }
        } catch (error) {
          /* try the next import map specifier */
        }
      }
      return null;
    };

    const replaceSectionNode = (sectionId, html) => {
      if (!sectionId || !html) return;
      const current = document.getElementById(`shopify-section-${sectionId}`);
      if (!current) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.getElementById(`shopify-section-${sectionId}`) || doc.body?.firstElementChild;
      if (!fresh) return;
      current.replaceWith(fresh);
    };

    document.addEventListener(
      'submit',
      async (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-bv-pcard-atc')) return;

        const themeForm = form.closest('product-form-component');
        if (themeForm && customElements.get('product-form-component')) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const productForm = form.closest('product-form-component') || form;
        const variantId = String(form.querySelector('[name="id"]')?.value || '');
        const quantity = Number(form.querySelector('[name="quantity"]')?.value) || 1;
        const button = form.querySelector('[name="add"]');
        if (button instanceof HTMLButtonElement) button.disabled = true;

        const CartLinesUpdateEvent = await loadCartLinesUpdateEvent();
        const deferred = CartLinesUpdateEvent?.createPromise?.();

        if (CartLinesUpdateEvent && deferred?.promise) {
          productForm.dispatchEvent(
            new CartLinesUpdateEvent({
              action: 'add',
              context: 'product',
              lines: [{ merchandiseId: variantId, quantity }],
              promise: deferred.promise,
            })
          );
        }

        try {
          const formData = new FormData(form);
          const sectionIds = cartSectionIds();
          if (sectionIds.length) {
            formData.set('sections', sectionIds.join(','));
            formData.set('sections_url', window.location.pathname);
          }

          const addResponse = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            credentials: 'same-origin',
            body: formData,
          });

          const addData = await addResponse.json();
          if (!addResponse.ok || addData.status) {
            throw new Error(addData.description || addData.message || 'Add to cart failed');
          }

          const cart = await fetch(`${root}cart.js`, {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin',
          }).then((res) => res.json());

          if (deferred && CartLinesUpdateEvent) {
            deferred.resolve({
              cart: CartLinesUpdateEvent.createCartFromAjaxResponse
                ? CartLinesUpdateEvent.createCartFromAjaxResponse(cart)
                : cart,
              detail: {
                items: cart.items,
                sections: addData.sections,
                itemCount: cart.item_count,
                source: 'product-form-component',
                didError: false,
              },
            });
          } else if (addData.sections) {
            Object.entries(addData.sections).forEach(([id, html]) => replaceSectionNode(id, html));
          }
        } catch (error) {
          console.error(error);
          deferred?.reject?.(error);
        } finally {
          if (button instanceof HTMLButtonElement) button.disabled = false;
        }
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
